export const buildQuery = (params) => {
    const query = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '' || value?.length === 0) return

        if (Array.isArray(value)) {
            value.forEach((v) => query.append(`${key}[]`, v))
            return
        }

        query.append(key, value)
    })

    return query.toString()
}
